import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { TenantService } from '@zaoblako/web/core/services/security/tenant.service';
import { WelcomeSystemStepEnum } from '@zaoblako/web/shared/components/welcome-system/enums/welcome-system-step.enum';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';

@Component({
  standalone: true,
  selector: 'crm-welcome-system-import-selection-type',
  templateUrl: './welcome-system-import-selection-type.component.html',
  imports: [CommonModule, ButtonComponent, SpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WelcomeSystemImportSelectionTypeComponent {
  public loading = false;
  @Output() public stepChange = new EventEmitter<WelcomeSystemStepEnum>();
  @Output() public onShowClose = new EventEmitter<boolean>();
  @Output() public closeModal = new EventEmitter<boolean>();

  public get WelcomeSystemStepEnum() {
    return WelcomeSystemStepEnum;
  }

  public constructor(
    private readonly tenantService: TenantService,
    private readonly errorService: ErrorService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public clickDemoAccount() {
    this.loading = true;
    this.onShowClose.emit(false);
    this.cdRef.markForCheck();

    this.tenantService.copyFromDemo().subscribe({
      next: () => {
        this.errorService.addSuccessMessage('Демо-аккаунт успешно создан');
        this.tenantService.disableWelcome().subscribe();
        this.loading = false;
        this.onShowClose.emit(true);
        this.closeModal.emit(false);
        this.cdRef.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.onShowClose.emit(true);
        this.cdRef.markForCheck();
      }
    });
  }

  public reminderWelcome() {
    this.tenantService.reminderWelcome().subscribe();
    this.closeModal.emit(true);
  }
}
